import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getFinDrivingData = createAsyncThunk("api/drivingLicense?type=2", async (token) => {
    try {
        const response = await nodeinstance.get("/drivingLicense?type=2", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const FinDrivingDataSlice = createSlice({
    name: "Driving",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFinDrivingData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getFinDrivingData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getFinDrivingData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getFinDrivingData };
export default FinDrivingDataSlice.reducer;
